import './styles.scss';
import {useDrop} from 'react-use';
import { useMemo, useState } from 'react';
import { csvParse } from 'd3-dsv';
import { useFirestore } from 'reactfire';
import { addDoc, collection, setDoc, doc } from 'firebase/firestore';
import parseGPS from './parseGPS';
import slug from 'slug'
import staticParksList from './parksList'
function ParkList(props) {
  const { parks } = props;

  return (
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
        </tr>
      </thead>
      <tbody>
        {parks.map((park, i) => (
          <tr key={i}>
            <td>{i + 1}</td>
            <td>{park}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function GroveList(props) {
  const { groves } = props
  console.log(groves)
  return (
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Year Dedicated</th>
          <th>Dedicated By</th>
          <th>Park</th>
          <th>GPS String</th>
        </tr>
      </thead>
      <tbody>
        {groves.map((grove, i) => (
          <tr key={i}>
            <td>{i + 1}</td>
            <td>{grove['Grove Name']}</td>
            <td>{grove['Year Dedicated']}</td>
            <td>{grove['Dedicated By']}</td>
            <td>{grove['Park']}</td>
            <td>{grove['GPS Coordinate']}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
export default function CMSCSVImport(props) {
  const [droppedFileData, setDroppedFileData] = useState(null);
  const fileState = useDrop({
    onFiles: async files => {
      console.log('files', files)
      const file = files[0]
      if (file && file.type === 'text/csv') {
        const contents = await file.text()
        console.log(contents)
        const rows = csvParse(contents)
        console.log(rows)
        rows.forEach(row => {
          const keys = Object.keys(row)
          keys.forEach(key => {
            row[key] = row[key].trim()
          })
        })
        // rows.length = 10
        setDroppedFileData(rows)
      }
    },
    onUri: uri => console.log('uri', uri),
    onText: text => console.log('text', text),
  });
  console.log(fileState)

  const parks = useMemo(() => {
    if (!droppedFileData) {
      return null;
    }
    console.log(droppedFileData)
    return Array.from(new Set([...droppedFileData.map(d => d.Park ), ...staticParksList])).filter(d => d).sort()
  }, [droppedFileData]);
  console.log(parks)

  const firestore = useFirestore()
  const grovesCollection = collection(firestore, 'groves')
  const parksCollection = collection(firestore, 'parks')


  const parksList = parks ? <ParkList parks={parks} /> : null;
  const grovesList = droppedFileData ? <GroveList groves={droppedFileData} /> : null;
  const importData = async () => {
    console.log('importData')
    const parksDocs = await Promise.all(parks.map(async park => {
      const parkDoc = doc(parksCollection, slug(park))
      await setDoc(parkDoc, { name: park })
      return parkDoc
    }))
    console.log(parksDocs)
    // const groveDocs = await Promise.all(batchGrovesIntoGroupsOf500.map(async groves => {
    //   const batch = writeBatch(firestore)
    const grovesDocs = await Promise.all(droppedFileData.map(grove => {
      // const parkDoc = parkDocs.find(d => d.name === grove.Park)
      const parkIndex = parks.indexOf(grove.Park)
      const parkDoc = parksDocs[parkIndex]
      const park = parkDoc ? parkDoc.id : null
      const gps = parseGPS(grove['GPS Coordinate'])
      console.log(gps, grove)
      const lat = gps ? gps[0] : null
      const lng = gps ? gps[1] : null
      return addDoc(grovesCollection, {
        name: grove['Grove Name'],
        yearDedicated: grove['Year Dedicated'],
        dedicatedBy: grove['Dedicated By'],
        park,
        gpsString: grove['GPS Coordinate'],
        lat,
        lng,
      })
    }))
    console.log(grovesDocs)



  }
  return (
    <div className='CMSCSVImport'>
      CMSCSVImport
      <div>
        {droppedFileData ?
          <button onClick={importData}>Import</button>
          : null}
    </div>
      {parksList}
      {grovesList}
    </div>
  )
}
